<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
  transformMarkedText,
} from '@/composables/splitSentence'

const props = defineProps({
  pData: Object,
  userName: String,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const fiveImo = ['☝️', '✌️', '🤟', '🖖', '🖐️']

const detailConnect = computed(() => removeAsterisk(props.pData.전체성향요약.상세연결))
const detailPersonality = computed(() => splitBySentence(props.pData.전체성향요약.상세특성))
const subConnect = computed(() => removeAsterisk(props.pData.전체성향요약.보조연결))
const subPersonality = computed(() => splitBySentence(props.pData.전체성향요약.보조특성))
const totalConnect = computed(() =>{
  const sentences = splitBySentence(props.pData.전체성향요약.종합연결 || '')
  return sentences.map(sentence => transformMarkedText(sentence))
})
const totalPersonality = computed(() => {
  const sentences = splitSentencesByDivider(props.pData.전체성향요약.종합특성)
  return sentences.map((s, idx) => {
    const emoji = fiveImo[idx] || ''
    return `${emoji} ${s}`
  })
})
const strengthItems = computed(() => splitCommaSeparatedWords(props.pData.전체성향요약.주요강점))
const weaknessItems = computed(() => splitCommaSeparatedWords(props.pData.전체성향요약.주요약점))
const strengthDetail = computed(() => splitBySentence(props.pData.전체성향요약.강점설명))
const weaknessDetail = computed(() => splitBySentence(props.pData.전체성향요약.약점설명))
const strengthAdvice = computed(() => props.pData.전체성향요약.강점조언)
const weaknessAdvice = computed(() => props.pData.전체성향요약.약점조언)
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <div class="person-content-box">
            <div class="content__title">🙂 이런 모습들이 나를 만들고 있어요</div>
            <div class="content__body-txt">
              <span class="p-keyword">{{ detailConnect }}</span>
            </div>
            <div v-for="(sentence, idx) in detailPersonality" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <div class="content__title">😎 때로는 이런 모습도 나타나요!</div>
            <div class="content__body-txt">
              <span class="p-keyword">{{ subConnect }}</span>
            </div>
            <div v-for="(sentence, idx) in subPersonality" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="person-content-box">
            <div class="content__title">📢 나의 성향을 한마디로 표현한다면?</div>
            <div 
              class="content__body-txt"
              v-html="totalConnect"
            >
            </div>
          </div>

          <div class="personality-divider" />

          <div class="person-content-box gray">
            <div class="content__title">나는 세상과 이렇게 어울려요.</div>
            <div v-for="(sentence, idx) in totalPersonality" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">💡 나를 빛나게 하는 강점들</div>
            <div class="desc__body blue">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in strengthItems" :key="idx" class="keyword-item blue">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in strengthDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">나의 강점을 발전시켜보세요. 🧐</div>
                <div class="white-box__desc">
                  {{ strengthAdvice }}
                </div>
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">🚨 놓치기 쉬운 내 마음의 신호들</div>
            <div class="desc__body red">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in weaknessItems" :key="idx" class="keyword-item red">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in weaknessDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">나를 위한 작은 쉼표 😌</div>
                <div class="white-box__desc">
                  {{ weaknessAdvice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
